<template>
	<span class="tit_area">
		<router-link to="/" @click.native="onLogoClick">
			<lottie :options="options" :width="170" :height="40" v-if="isDefaultLogo" />
			<ci-logo v-else />
		</router-link>
	</span>
</template>

<script>
import { defineComponent } from '@vue/composition-api/dist/vue-composition-api';
import Lottie from 'vue-lottie';
import CiLogo from '@/Layout/common/ciLogo';
import * as animationData from '@/assets/json/lottie/logo.json';
import { useStore } from '@vueblocks/vue-use-vuex';

export default defineComponent({
	name: 'headerLogo',
	components: {
		lottie: Lottie,
		CiLogo,
	},
	props: {
		onLogoClick: {
			type: Function,
			require: true,
		},
	},
	data() {
		return {
			options: {
				animationData: animationData.default,
			},
		};
	},
	computed: {
		isDefaultLogo() {
			const store = useStore();

			let isNotLoginLogin = !store.getters.isLoggedIn;
			let isEmptyCiImage = !store.getters.userInfo.ciImageUrl;

			return isNotLoginLogin || isEmptyCiImage;
		},
	},
});
</script>

<style lang="less" scoped>
.tit_area {
	> a {
		display: flex;
		align-items: center;
	}
}
</style>
